import React, { memo, Suspense } from "react";
import styles from "./PreLogin.module.scss";
import { Outlet } from "react-router-dom";
import Loader from "@/components/Loader/Loader";

const PreLogin = () => {
  return (
    <div className={styles.mainContainer}>
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    </div>
  );
};

export default memo(PreLogin);
